import { render, staticRenderFns } from "./UserTastePanel.vue?vue&type=template&id=107428aa&scoped=true&"
import script from "./UserTastePanel.vue?vue&type=script&lang=js&"
export * from "./UserTastePanel.vue?vue&type=script&lang=js&"
import style0 from "./UserTastePanel.vue?vue&type=style&index=0&id=107428aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107428aa",
  null
  
)

export default component.exports